"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".root_4741804c{background-color:" }, { "theme": "whiteTranslucent40", "defaultValue": "rgba(255,255,255,.4)" }, { "rawString": ";position:absolute;bottom:0;left:0;right:0;top:0}.root_4741804c.rootIsNone_4741804c{visibility:hidden}.root_4741804c.rootIsDark_4741804c{background-color:" }, { "theme": "blackTranslucent40", "defaultValue": "rgba(0,0,0,.4)" }, { "rawString": "}@media screen and (-ms-high-contrast: active){.root_4741804c{border:1px solid WindowText}}\n" }]);
exports.root = "root_4741804c";
exports.rootIsNone = "rootIsNone_4741804c";
exports.rootIsDark = "rootIsDark_4741804c";
//# sourceMappingURL=Overlay.scss.js.map


//////////////////
// WEBPACK FOOTER
// ../~/office-ui-fabric-react/lib/components/Overlay/Overlay.scss.js
// module id = ../node_modules/office-ui-fabric-react/lib/components/Overlay/Overlay.scss.js
// module chunks = 1